import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4b31aad8&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./assets/index.scss?vue&type=style&index=0&id=4b31aad8&prod&scoped=true&lang=scss&external"
import style1 from "./index.vue?vue&type=style&index=1&id=4b31aad8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b31aad8",
  null
  
)

export default component.exports